export function injectScriptOnce(opts: {
    id: string;
    src: string;
    attrs?: Record<string, string>;
    before?: 'head' | 'body' | 'head-prepend';
}): Promise<void> {
    return new Promise((resolve, reject) => {
        const existing = document.getElementById(opts.id) as HTMLScriptElement | null;
        if (existing) {
            if (existing.getAttribute('data-loaded') === '1') return resolve();
            existing.addEventListener('load', () => resolve());
            existing.addEventListener('error', () => reject(new Error(`Script ${opts.id} failed`)));
            return;
        }

        const s = document.createElement('script');
        s.id = opts.id;
        s.src = opts.src;
        s.async = true;
        if (opts.attrs) {
            for (const [k, v] of Object.entries(opts.attrs)) s.setAttribute(k, String(v));
        }
        s.addEventListener('load', () => {
            s.setAttribute('data-loaded', '1');
            resolve();
        });
        s.addEventListener('error', () => reject(new Error(`Script ${opts.id} failed`)));

        const head = document.head;
        const body = document.body;
        if (opts.before === 'head-prepend') head.prepend(s);
        else if (opts.before === 'body') body.appendChild(s);
        else head.appendChild(s);
    });
}

export function deepEqual(a: any, b: any) {
    try {
        return JSON.stringify(a) === JSON.stringify(b);
    } catch {
        return false;
    }
}

// src/thirdParty/consent/hideUsercentricsPrivacyButton.ts
export function hideUsercentricsPrivacyButton() {
    const tryHide = (host: HTMLElement | null) => {
        if (!host) return;
        const sr = (host as any).shadowRoot as ShadowRoot | null;
        if (!sr) return;

        // Häufige Selektoren (können je Theme variieren):
        const candidates = [
            '[data-testid="uc-privacy-button"]',
            'button[aria-label*="privacy" i]',
            'button[aria-label*="cookie" i]',
            'button[id^="uc-privacy"]',
        ];

        for (const sel of candidates) {
            const el = sr.querySelector(sel) as HTMLElement | null;
            if (el) {
                el.style.setProperty('display', 'none', 'important');
                el.style.setProperty('visibility', 'hidden', 'important');
            }
        }
    };

    const host = document.getElementById('usercentrics-root');

    // 1) Sofort versuchen
    tryHide(host);

    // 2) Wenn Shadow DOM/Elemente später kommen → beobachten und erneut verstecken
    const reapply = () => tryHide(document.getElementById('usercentrics-root'));

    // Observer für Shadow-DOM Änderungen
    if (host) {
        const moHost = new MutationObserver(() => {
            const sr = (host as any).shadowRoot as ShadowRoot | null;
            if (!sr) return;
            tryHide(host);
            const moShadow = new MutationObserver(() => tryHide(host));
            moShadow.observe(sr, { childList: true, subtree: true });
            moHost.disconnect();
        });
        moHost.observe(host, { childList: true });
    }

    // Sicherheitsnetz: alle 500ms kurz nachfassen, 5x
    let attempts = 0;
    const iv = setInterval(() => {
        attempts++;
        reapply();
        if (attempts >= 5) clearInterval(iv);
    }, 500);
}
